import styled, { css } from 'styled-components';

export const TruckName = styled.h1`
  font-size: ${({ theme }) => theme.fontSize.xl};
  flex: 2 1 0;
  margin: 0;
  font-weight: normal;

  ${({ status, theme }) => {
    if (status === 'archived') {
      return css`
        text-decoration-line: line-through;
        color: ${theme.colors.color_darkgray};
      `;
    }
    return null;
  }}

  @media (max-width: 512px) {
    margin-left: 0px;
    font-size: ${({ theme }) => theme.fontSize.xm};
  }
`;
